import { render, staticRenderFns } from "./InventoryHistory.vue?vue&type=template&id=1a82ec37"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"
import style0 from "./InventoryHistory.vue?vue&type=style&index=0&id=1a82ec37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports